import { actions } from '@/modules/SuiviFactures/store/modules/SuiviFacturesPayees/actions';
import { state, SuiviFacturesPayeesState } from '@/modules/SuiviFactures/store/modules/SuiviFacturesPayees/state';
import { RootState } from '@/plugins/store';
import { Module } from 'vuex';
import { mutations } from './mutations';
import { getters } from './getters';

const module: Module<SuiviFacturesPayeesState, RootState> = {
    state,
    actions,
    mutations,
    getters,
};

export default module;
export type { SuiviFacturesPayeesState };
